// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kore-chat-window .popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1010;
  display: none;
  max-width: 276px;
  padding: 1px;
  text-align: left;
  white-space: normal;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
}

.kore-chat-window .popover.top {
  margin-top: -10px;
}

.kore-chat-window .popover.right {
  margin-left: 10px;
}

.kore-chat-window .popover.bottom {
  margin-top: 10px;
}

.kore-chat-window .popover.left {
  margin-left: -10px;
}

.kore-chat-window .popover-title {
  padding: 8px 14px;
  margin: 0;
  font-size: 14px;
  font-weight: normal;
  line-height: 18px;
  background-color: #f7f7f7;
  border-bottom: 1px solid #ebebeb;
  border-radius: 5px 5px 0 0;
}

.kore-chat-window .popover-content {
  padding: 9px 14px;
}

.kore-chat-window .popover > .arrow,
.kore-chat-window .popover > .arrow:after {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
  /* The following are set in WordPress (wp-admin/css/revisions.css) - reset them to initial values */
  overflow: visible;
  margin: 0;
  padding: 0;
  z-index: auto;
  background-color: transparent;
  -webkit-box-shadow: none;
  box-shadow: none;
  bottom: auto;
  left: auto;
  right: auto;
  top: auto;
  -webkit-transform: none;
  -ms-transform: none;
  transform: none;
}

.kore-chat-window .popover > .arrow {
  border-width: 11px;
}

.kore-chat-window .popover > .arrow:after {
  content: "";
  border-width: 10px;
}

.kore-chat-window .popover.top > .arrow {
  bottom: -11px;
  left: 50%;
  margin-left: -11px;
  border-top-color: #999;
  border-top-color: rgba(0, 0, 0, 0.25);
  border-bottom-width: 0;
}

.kore-chat-window .popover.top > .arrow:after {
  bottom: 1px;
  margin-left: -10px;
  content: " ";
  border-top-color: #fff;
  border-bottom-width: 0;
}

.kore-chat-window .popover.right > .arrow {
  top: 50%;
  left: -11px;
  margin-top: -11px;
  border-right-color: #999;
  border-right-color: rgba(0, 0, 0, 0.25);
  border-left-width: 0;
}

.kore-chat-window .popover.right > .arrow:after {
  bottom: -10px;
  left: 1px;
  content: " ";
  border-right-color: #fff;
  border-left-width: 0;
}

.kore-chat-window .popover.bottom > .arrow {
  top: -11px;
  left: 50%;
  margin-left: -11px;
  border-top-width: 0;
  border-bottom-color: #999;
  border-bottom-color: rgba(0, 0, 0, 0.25);
}

.kore-chat-window .popover.bottom > .arrow:after {
  top: 1px;
  margin-left: -10px;
  content: " ";
  border-top-width: 0;
  border-bottom-color: #fff;
}

.kore-chat-window .popover.left > .arrow {
  top: 50%;
  right: -11px;
  margin-top: -11px;
  border-right-width: 0;
  border-left-color: #999;
  border-left-color: rgba(0, 0, 0, 0.25);
}

.kore-chat-window .popover.left > .arrow:after {
  right: 1px;
  bottom: -10px;
  content: " ";
  border-right-width: 0;
  border-left-color: #fff;
}

.kore-chat-window .btn {
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
}

.kore-chat-window .btn:focus,
.kore-chat-window .btn:active:focus,
.kore-chat-window .btn.active:focus {
  outline: thin dotted;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}

.kore-chat-window .btn:hover,
.kore-chat-window .btn:focus {
  color: #333;
  text-decoration: none;
}

.kore-chat-window .btn:active,
.kore-chat-window .btn.active {
  background-image: none;
  outline: 0;
  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}

.kore-chat-window .btn-default {
  color: #333;
  background-color: #fff;
  border-color: #ccc;
}

.kore-chat-window .btn-default:hover,
.kore-chat-window .btn-default:focus,
.kore-chat-window .btn-default:active,
.kore-chat-window .btn-default.active,
.kore-chat-window .open .dropdown-toggle.btn-default {
  color: #333;
  background-color: #ebebeb;
  border-color: #adadad;
}

.kore-chat-window .btn-default:active,
.kore-chat-window .btn-default.active,
.kore-chat-window .open .dropdown-toggle.btn-default {
  background-image: none;
}

.kore-chat-window .btn-block {
  display: block;
  width: 100%;
}

.kore-chat-window .text-primary {
  color: #428bca;
}

.kore-chat-window .clockpicker .input-group-addon {
  cursor: pointer;
}

.kore-chat-window .clockpicker-moving {
  cursor: move;
}

.kore-chat-window .clockpicker-align-left.popover > .arrow {
  left: 25px;
}

.kore-chat-window .clockpicker-align-top.popover > .arrow {
  top: 17px;
}

.kore-chat-window .clockpicker-align-right.popover > .arrow {
  left: auto;
  right: 25px;
}

.kore-chat-window .clockpicker-align-bottom.popover > .arrow {
  top: auto;
  bottom: 6px;
}

.kore-chat-window .clockpicker-popover .popover-title {
  background-color: #fff;
  color: #999;
  font-size: 24px;
  font-weight: bold;
  line-height: 30px;
  text-align: center;
}

.kore-chat-window .clockpicker-popover .popover-title span {
  cursor: pointer;
}

.kore-chat-window .clockpicker-popover .popover-content {
  background-color: #f8f8f8;
  padding: 12px;
}

.kore-chat-window .popover-content:last-child {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.kore-chat-window .clockpicker-plate {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  width: 200px;
  height: 200px;
  overflow: visible;
  position: relative;
  /* Disable text selection highlighting. Thanks to Hermanya */
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.kore-chat-window .clockpicker-canvas,
.kore-chat-window .clockpicker-dial {
  width: 200px;
  height: 200px;
  position: absolute;
  left: -1px;
  top: -1px;
}

.kore-chat-window .clockpicker-minutes {
  visibility: hidden;
}

.kore-chat-window .clockpicker-tick {
  border-radius: 50%;
  color: #666;
  line-height: 26px;
  text-align: center;
  width: 26px;
  height: 26px;
  position: absolute;
  cursor: pointer;
}

.kore-chat-window .clockpicker-tick.active,
.kore-chat-window .clockpicker-tick:hover {
  background-color: #c0e5f7;
  background-color: rgba(0, 149, 221, 0.25);
}

.kore-chat-window .clockpicker-button {
  background-image: none;
  background-color: #fff;
  border-width: 1px 0 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  margin: 0;
  padding: 10px 0;
}

.kore-chat-window .clockpicker-button:hover {
  background-image: none;
  background-color: #ebebeb;
}

.kore-chat-window .clockpicker-button:focus {
  outline: none !important;
}

.kore-chat-window .clockpicker-dial {
  -webkit-transition: -webkit-transform 350ms, opacity 350ms;
  -moz-transition: -moz-transform 350ms, opacity 350ms;
  -ms-transition: -ms-transform 350ms, opacity 350ms;
  -o-transition: -o-transform 350ms, opacity 350ms;
  transition: transform 350ms, opacity 350ms;
}

.kore-chat-window .clockpicker-dial-out {
  opacity: 0;
}

.kore-chat-window .clockpicker-hours.clockpicker-dial-out {
  -webkit-transform: scale(1.2, 1.2);
  -moz-transform: scale(1.2, 1.2);
  -ms-transform: scale(1.2, 1.2);
  -o-transform: scale(1.2, 1.2);
  transform: scale(1.2, 1.2);
}

.kore-chat-window .clockpicker-minutes.clockpicker-dial-out {
  -webkit-transform: scale(0.8, 0.8);
  -moz-transform: scale(0.8, 0.8);
  -ms-transform: scale(0.8, 0.8);
  -o-transform: scale(0.8, 0.8);
  transform: scale(0.8, 0.8);
}

.kore-chat-window .clockpicker-canvas {
  -webkit-transition: opacity 175ms;
  -moz-transition: opacity 175ms;
  -ms-transition: opacity 175ms;
  -o-transition: opacity 175ms;
  transition: opacity 175ms;
}

.kore-chat-window .clockpicker-canvas-out {
  opacity: 0.25;
}

.kore-chat-window .clockpicker-canvas-bearing,
.kore-chat-window .clockpicker-canvas-fg {
  stroke: none;
  fill: #0095dd;
}

.kore-chat-window .clockpicker-canvas-bg {
  stroke: none;
  fill: #c0e5f7;
}

.kore-chat-window .clockpicker-canvas-bg-trans {
  fill: rgba(0, 149, 221, 0.25);
}

.kore-chat-window .clockpicker-canvas line {
  stroke: #0095dd;
  stroke-width: 1;
  stroke-linecap: round;
  /*shape-rendering: crispEdges;
  */
}

.kore-chat-window .clockpicker-button.am-button {
  margin: 1px;
  padding: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.kore-chat-window .clockpicker-button.pm-button {
  margin: 1px 1px 1px 136px;
  padding: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/libs/jquery-clockpicker/jquery-clockpicker.css"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iDAAA;EACA,yCAAA;AACD;;AAEA;EACC,iBAAA;AACD;;AAEA;EACC,iBAAA;AACD;;AAEA;EACC,gBAAA;AACD;;AAEA;EACC,kBAAA;AACD;;AAEA;EACC,iBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gCAAA;EACA,0BAAA;AACD;;AAEA;EACC,iBAAA;AACD;;AAEA;;EAEC,kBAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,mGAAA;EACA,iBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,6BAAA;EACA,wBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AACD;;AAEA;EACC,kBAAA;AACD;;AAEA;EACC,WAAA;EACA,kBAAA;AACD;;AAEA;EACC,aAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,qCAAA;EACA,sBAAA;AACD;;AAEA;EACC,WAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;AACD;;AAEA;EACC,QAAA;EACA,WAAA;EACA,iBAAA;EACA,wBAAA;EACA,uCAAA;EACA,oBAAA;AACD;;AAEA;EACC,aAAA;EACA,SAAA;EACA,YAAA;EACA,wBAAA;EACA,oBAAA;AACD;;AAEA;EACC,UAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,wCAAA;AACD;;AAEA;EACC,QAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;AACD;;AAEA;EACC,QAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,uBAAA;EACA,sCAAA;AACD;;AAEA;EACC,UAAA;EACA,aAAA;EACA,YAAA;EACA,qBAAA;EACA,uBAAA;AACD;;AAEA;EACC,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,sBAAA;EACA,6BAAA;AACD;;AAEA;;;EAGC,oBAAA;EACA,0CAAA;EACA,oBAAA;AACD;;AAEA;;EAEC,WAAA;EACA,qBAAA;AACD;;AAEA;;EAEC,sBAAA;EACA,UAAA;EACA,wDAAA;EACA,gDAAA;AACD;;AAEA;EACC,WAAA;EACA,sBAAA;EACA,kBAAA;AACD;;AAEA;;;;;EAKC,WAAA;EACA,yBAAA;EACA,qBAAA;AACD;;AAEA;;;EAGC,sBAAA;AACD;;AAEA;EACC,cAAA;EACA,WAAA;AACD;;AAEA;EACC,cAAA;AACD;;AAEA;EACC,eAAA;AACD;;AAEA;EACC,YAAA;AACD;;AAEA;EACC,UAAA;AACD;;AAEA;EACC,SAAA;AACD;;AAEA;EACC,UAAA;EACA,WAAA;AACD;;AAEA;EACC,SAAA;EACA,WAAA;AACD;;AAEA;EACC,sBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AACD;;AAEA;EACC,eAAA;AACD;;AAEA;EACC,yBAAA;EACA,aAAA;AACD;;AAEA;EACC,8BAAA;EACA,+BAAA;AACD;;AAEA;EACC,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,4DAAA;EACA,2BAAA;EACA,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AACD;;AAEA;;EAEC,YAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AACD;;AAEA;EACC,kBAAA;AACD;;AAEA;EACC,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AACD;;AAEA;;EAEC,yBAAA;EACA,yCAAA;AACD;;AAEA;EACC,sBAAA;EACA,sBAAA;EACA,qBAAA;EACA,yBAAA;EACA,0BAAA;EACA,SAAA;EACA,eAAA;AACD;;AAEA;EACC,sBAAA;EACA,yBAAA;AACD;;AAEA;EACC,wBAAA;AACD;;AAEA;EACC,0DAAA;EACA,oDAAA;EACA,kDAAA;EACA,gDAAA;EACA,0CAAA;AACD;;AAEA;EACC,UAAA;AACD;;AAEA;EACC,kCAAA;EACA,+BAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;AACD;;AAEA;EACC,kCAAA;EACA,+BAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;AACD;;AAEA;EACC,iCAAA;EACA,8BAAA;EACA,6BAAA;EACA,4BAAA;EACA,yBAAA;AACD;;AAEA;EACC,aAAA;AACD;;AAEA;;EAEC,YAAA;EACA,aAAA;AACD;;AAEA;EACC,YAAA;EACA,aAAA;AACD;;AAEA;EACC,6BAAA;AACD;;AAEA;EACC,eAAA;EACA,eAAA;EACA,qBAAA;EACA;GAAA;AAED;;AAEA;EACC,WAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;AACD;;AAEA;EACC,yBAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;AACD","sourcesContent":[".kore-chat-window .popover {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tz-index: 1010;\n\tdisplay: none;\n\tmax-width: 276px;\n\tpadding: 1px;\n\ttext-align: left;\n\twhite-space: normal;\n\tbackground-color: #fff;\n\tbackground-clip: padding-box;\n\tborder: 1px solid #ccc;\n\tborder: 1px solid rgba(0, 0, 0, .2);\n\tborder-radius: 6px;\n\t-webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, .2);\n\tbox-shadow: 0 5px 10px rgba(0, 0, 0, .2);\n}\n\n.kore-chat-window .popover.top {\n\tmargin-top: -10px;\n}\n\n.kore-chat-window .popover.right {\n\tmargin-left: 10px;\n}\n\n.kore-chat-window .popover.bottom {\n\tmargin-top: 10px;\n}\n\n.kore-chat-window .popover.left {\n\tmargin-left: -10px;\n}\n\n.kore-chat-window .popover-title {\n\tpadding: 8px 14px;\n\tmargin: 0;\n\tfont-size: 14px;\n\tfont-weight: normal;\n\tline-height: 18px;\n\tbackground-color: #f7f7f7;\n\tborder-bottom: 1px solid #ebebeb;\n\tborder-radius: 5px 5px 0 0;\n}\n\n.kore-chat-window .popover-content {\n\tpadding: 9px 14px;\n}\n\n.kore-chat-window .popover>.arrow,\n.kore-chat-window .popover>.arrow:after {\n\tposition: absolute;\n\tdisplay: block;\n\twidth: 0;\n\theight: 0;\n\tborder-color: transparent;\n\tborder-style: solid;\n\t/* The following are set in WordPress (wp-admin/css/revisions.css) - reset them to initial values */\n\toverflow: visible;\n\tmargin: 0;\n\tpadding: 0;\n\tz-index: auto;\n\tbackground-color: transparent;\n\t-webkit-box-shadow: none;\n\tbox-shadow: none;\n\tbottom: auto;\n\tleft: auto;\n\tright: auto;\n\ttop: auto;\n\t-webkit-transform: none;\n\t-ms-transform: none;\n\ttransform: none;\n}\n\n.kore-chat-window .popover>.arrow {\n\tborder-width: 11px;\n}\n\n.kore-chat-window .popover>.arrow:after {\n\tcontent: \"\";\n\tborder-width: 10px;\n}\n\n.kore-chat-window .popover.top>.arrow {\n\tbottom: -11px;\n\tleft: 50%;\n\tmargin-left: -11px;\n\tborder-top-color: #999;\n\tborder-top-color: rgba(0, 0, 0, .25);\n\tborder-bottom-width: 0;\n}\n\n.kore-chat-window .popover.top>.arrow:after {\n\tbottom: 1px;\n\tmargin-left: -10px;\n\tcontent: \" \";\n\tborder-top-color: #fff;\n\tborder-bottom-width: 0;\n}\n\n.kore-chat-window .popover.right>.arrow {\n\ttop: 50%;\n\tleft: -11px;\n\tmargin-top: -11px;\n\tborder-right-color: #999;\n\tborder-right-color: rgba(0, 0, 0, .25);\n\tborder-left-width: 0;\n}\n\n.kore-chat-window .popover.right>.arrow:after {\n\tbottom: -10px;\n\tleft: 1px;\n\tcontent: \" \";\n\tborder-right-color: #fff;\n\tborder-left-width: 0;\n}\n\n.kore-chat-window .popover.bottom>.arrow {\n\ttop: -11px;\n\tleft: 50%;\n\tmargin-left: -11px;\n\tborder-top-width: 0;\n\tborder-bottom-color: #999;\n\tborder-bottom-color: rgba(0, 0, 0, .25);\n}\n\n.kore-chat-window .popover.bottom>.arrow:after {\n\ttop: 1px;\n\tmargin-left: -10px;\n\tcontent: \" \";\n\tborder-top-width: 0;\n\tborder-bottom-color: #fff;\n}\n\n.kore-chat-window .popover.left>.arrow {\n\ttop: 50%;\n\tright: -11px;\n\tmargin-top: -11px;\n\tborder-right-width: 0;\n\tborder-left-color: #999;\n\tborder-left-color: rgba(0, 0, 0, .25);\n}\n\n.kore-chat-window .popover.left>.arrow:after {\n\tright: 1px;\n\tbottom: -10px;\n\tcontent: \" \";\n\tborder-right-width: 0;\n\tborder-left-color: #fff;\n}\n\n.kore-chat-window .btn {\n\tcursor: pointer;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n\tbackground-image: none;\n\tborder: 1px solid transparent;\n}\n\n.kore-chat-window .btn:focus,\n.kore-chat-window .btn:active:focus,\n.kore-chat-window .btn.active:focus {\n\toutline: thin dotted;\n\toutline: 5px auto -webkit-focus-ring-color;\n\toutline-offset: -2px;\n}\n\n.kore-chat-window .btn:hover,\n.kore-chat-window .btn:focus {\n\tcolor: #333;\n\ttext-decoration: none;\n}\n\n.kore-chat-window .btn:active,\n.kore-chat-window .btn.active {\n\tbackground-image: none;\n\toutline: 0;\n\t-webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n\tbox-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n}\n\n.kore-chat-window .btn-default {\n\tcolor: #333;\n\tbackground-color: #fff;\n\tborder-color: #ccc;\n}\n\n.kore-chat-window .btn-default:hover,\n.kore-chat-window .btn-default:focus,\n.kore-chat-window .btn-default:active,\n.kore-chat-window .btn-default.active,\n.kore-chat-window .open .dropdown-toggle.btn-default {\n\tcolor: #333;\n\tbackground-color: #ebebeb;\n\tborder-color: #adadad;\n}\n\n.kore-chat-window .btn-default:active,\n.kore-chat-window .btn-default.active,\n.kore-chat-window .open .dropdown-toggle.btn-default {\n\tbackground-image: none;\n}\n\n.kore-chat-window .btn-block {\n\tdisplay: block;\n\twidth: 100%;\n}\n\n.kore-chat-window .text-primary {\n\tcolor: #428bca;\n}\n\n.kore-chat-window .clockpicker .input-group-addon {\n\tcursor: pointer;\n}\n\n.kore-chat-window .clockpicker-moving {\n\tcursor: move;\n}\n\n.kore-chat-window .clockpicker-align-left.popover>.arrow {\n\tleft: 25px;\n}\n\n.kore-chat-window .clockpicker-align-top.popover>.arrow {\n\ttop: 17px;\n}\n\n.kore-chat-window .clockpicker-align-right.popover>.arrow {\n\tleft: auto;\n\tright: 25px;\n}\n\n.kore-chat-window .clockpicker-align-bottom.popover>.arrow {\n\ttop: auto;\n\tbottom: 6px;\n}\n\n.kore-chat-window .clockpicker-popover .popover-title {\n\tbackground-color: #fff;\n\tcolor: #999;\n\tfont-size: 24px;\n\tfont-weight: bold;\n\tline-height: 30px;\n\ttext-align: center;\n}\n\n.kore-chat-window .clockpicker-popover .popover-title span {\n\tcursor: pointer;\n}\n\n.kore-chat-window .clockpicker-popover .popover-content {\n\tbackground-color: #f8f8f8;\n\tpadding: 12px;\n}\n\n.kore-chat-window .popover-content:last-child {\n\tborder-bottom-left-radius: 5px;\n\tborder-bottom-right-radius: 5px;\n}\n\n.kore-chat-window .clockpicker-plate {\n\tbackground-color: #fff;\n\tborder: 1px solid #ccc;\n\tborder-radius: 50%;\n\twidth: 200px;\n\theight: 200px;\n\toverflow: visible;\n\tposition: relative;\n\t/* Disable text selection highlighting. Thanks to Hermanya */\n\t-webkit-touch-callout: none;\n\t-webkit-user-select: none;\n\t-khtml-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n}\n\n.kore-chat-window .clockpicker-canvas,\n.kore-chat-window .clockpicker-dial {\n\twidth: 200px;\n\theight: 200px;\n\tposition: absolute;\n\tleft: -1px;\n\ttop: -1px;\n}\n\n.kore-chat-window .clockpicker-minutes {\n\tvisibility: hidden;\n}\n\n.kore-chat-window .clockpicker-tick {\n\tborder-radius: 50%;\n\tcolor: #666;\n\tline-height: 26px;\n\ttext-align: center;\n\twidth: 26px;\n\theight: 26px;\n\tposition: absolute;\n\tcursor: pointer;\n}\n\n.kore-chat-window .clockpicker-tick.active,\n.kore-chat-window .clockpicker-tick:hover {\n\tbackground-color: #c0e5f7;\n\tbackground-color: rgba(0, 149, 221, .25);\n}\n\n.kore-chat-window .clockpicker-button {\n\tbackground-image: none;\n\tbackground-color: #fff;\n\tborder-width: 1px 0 0;\n\tborder-top-left-radius: 0;\n\tborder-top-right-radius: 0;\n\tmargin: 0;\n\tpadding: 10px 0;\n}\n\n.kore-chat-window .clockpicker-button:hover {\n\tbackground-image: none;\n\tbackground-color: #ebebeb;\n}\n\n.kore-chat-window .clockpicker-button:focus {\n\toutline: none !important;\n}\n\n.kore-chat-window .clockpicker-dial {\n\t-webkit-transition: -webkit-transform 350ms, opacity 350ms;\n\t-moz-transition: -moz-transform 350ms, opacity 350ms;\n\t-ms-transition: -ms-transform 350ms, opacity 350ms;\n\t-o-transition: -o-transform 350ms, opacity 350ms;\n\ttransition: transform 350ms, opacity 350ms;\n}\n\n.kore-chat-window .clockpicker-dial-out {\n\topacity: 0;\n}\n\n.kore-chat-window .clockpicker-hours.clockpicker-dial-out {\n\t-webkit-transform: scale(1.2, 1.2);\n\t-moz-transform: scale(1.2, 1.2);\n\t-ms-transform: scale(1.2, 1.2);\n\t-o-transform: scale(1.2, 1.2);\n\ttransform: scale(1.2, 1.2);\n}\n\n.kore-chat-window .clockpicker-minutes.clockpicker-dial-out {\n\t-webkit-transform: scale(0.8, 0.8);\n\t-moz-transform: scale(0.8, 0.8);\n\t-ms-transform: scale(0.8, 0.8);\n\t-o-transform: scale(0.8, 0.8);\n\ttransform: scale(0.8, 0.8);\n}\n\n.kore-chat-window .clockpicker-canvas {\n\t-webkit-transition: opacity 175ms;\n\t-moz-transition: opacity 175ms;\n\t-ms-transition: opacity 175ms;\n\t-o-transition: opacity 175ms;\n\ttransition: opacity 175ms;\n}\n\n.kore-chat-window .clockpicker-canvas-out {\n\topacity: 0.25;\n}\n\n.kore-chat-window .clockpicker-canvas-bearing,\n.kore-chat-window .clockpicker-canvas-fg {\n\tstroke: none;\n\tfill: #0095dd;\n}\n\n.kore-chat-window .clockpicker-canvas-bg {\n\tstroke: none;\n\tfill: #c0e5f7;\n}\n\n.kore-chat-window .clockpicker-canvas-bg-trans {\n\tfill: rgba(0, 149, 221, .25);\n}\n\n.kore-chat-window .clockpicker-canvas line {\n\tstroke: #0095dd;\n\tstroke-width: 1;\n\tstroke-linecap: round;\n\t/*shape-rendering: crispEdges;\n\t*/\n}\n\n.kore-chat-window .clockpicker-button.am-button {\n\tmargin: 1px;\n\tpadding: 5px;\n\tborder: 1px solid rgba(0, 0, 0, .2);\n\tborder-radius: 4px;\n}\n\n.kore-chat-window .clockpicker-button.pm-button {\n\tmargin: 1px 1px 1px 136px;\n\tpadding: 5px;\n\tborder: 1px solid rgba(0, 0, 0, .2);\n\tborder-radius: 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
